// client/src/components/TimeSelect.jsx
// Canonical 24-hour time picker for the whole app. Two dropdowns (HH 00–23,
// MM in 5-min steps) — NEVER the browser's locale-driven AM/PM <input
// type="time">. Israel runs on a 24-hour clock; there is no AM/PM anywhere.
// Value is an "HH:MM" string; a stored off-step minute is injected so it
// isn't lost when editing.

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
const MINUTES = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

export default function TimeSelect({ value, onChange }) {
  const [h = '00', m = '00'] = (value || '00:00').split(':');
  const minutes = MINUTES.includes(m) ? MINUTES : [...MINUTES, m].sort();
  const selCls =
    'rounded-xl border border-ink-300 bg-white px-2.5 py-2 text-sm font-bold num focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-200';
  return (
    <span className="inline-flex items-center gap-1" dir="ltr">
      <select className={selCls} value={h} onChange={(e) => onChange(`${e.target.value}:${m}`)} aria-label="שעה">
        {HOURS.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <span className="text-ink-400 font-bold">:</span>
      <select className={selCls} value={m} onChange={(e) => onChange(`${h}:${e.target.value}`)} aria-label="דקה">
        {minutes.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
    </span>
  );
}
